function checkContrast(firstColor, secondColor) {
  return (Math.max(firstColor, secondColor) + 0.05) / (Math.min(firstColor, secondColor) + 0.05);
}

function combineRgbValues(red, green, blue) {
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
}

function calculateIndividualRgbValue(color) {
  return color <= 0.03928 ? color / 12.92 : Math.pow((color + 0.055) / 1.055, 2.4);
}

function calculateRgb(rgbColor) {
  let rgbValues = rgbColor.split('(')[1].split(')')[0];
  rgbValues = rgbValues.split(',');

  const R = calculateIndividualRgbValue(rgbValues[0] / 255);
  const G = calculateIndividualRgbValue(rgbValues[1] / 255);
  const B = calculateIndividualRgbValue(rgbValues[2] / 255);

  return combineRgbValues(R, G, B);
}

function calculateHex(hexColor) {
  const hex = hexColor.replace('#', '');

  let R = parseInt(hex.substring(0, 2), 16);
  let G = parseInt(hex.substring(2, 4), 16);
  let B = parseInt(hex.substring(4, 6), 16);

  R = calculateIndividualRgbValue(R / 255);
  G = calculateIndividualRgbValue(G / 255);
  B = calculateIndividualRgbValue(B / 255);

  return combineRgbValues(R, G, B);
}

function calculateColor(color) {
  let calculatedColor;
  if (color.indexOf('#') !== -1 || color.indexOf(',') === -1) {
    calculatedColor = calculateHex(color);
  } else {
    calculatedColor = calculateRgb(color);
  }

  return calculatedColor;
}

export default function(firstColor, secondColor) {
  // We have to provide defaults for the contrast checker in order for it to work
  // Gray blue for the background and white for the foreground;
  const backgroundColor = firstColor ? firstColor : '45515E';
  const foregroundColor = secondColor ? secondColor : 'rgba(255, 255, 255, 0.9)';

  // This converts the colors provided into something we can compare in the
  // actual contrast check
  const calculatedBackgroundColor = calculateColor(backgroundColor);
  const calculatedForegroundColor = calculateColor(foregroundColor);

  // Check contrast for first and second color.
  // Pass? return secondColor.
  // Fail? check against white and return white if passed.
  // Fail? return black.
  if (checkContrast(calculatedBackgroundColor, calculatedForegroundColor) > 3) {
    if (foregroundColor.indexOf(',') === -1) {
      return '#' + foregroundColor;
    }
    return foregroundColor;
  } else if (checkContrast(calculatedBackgroundColor, 1) > 3) {
    return 'rgba(255, 255, 255, 0.9)';
  }

  return 'rgba(0, 0, 0, 0.6)';
}



// WEBPACK FOOTER //
// ./src/__utils/contrastChecker.js